// Directory.js
import React, { useState } from "react";
import "./Directory.css";
import { FiMail, FiChevronDown, FiSearch } from "react-icons/fi";

const clubs = [
  {
    id: 1,
    name: "Aspira",
    description: "Entrepreneurship and business club promoting leadership in finance, business, and innovation. We host regular workshops, networking events, and startup competitions to foster entrepreneurial spirit among students.",
    contact: "https://www.instagram.com/aspira_youth/",
    category: "Business",
    founded: 2024,
    members: 120
  },
  {
    id: 2,
    name: "Finance Club",
    description: "Promotes financial literacy and investment knowledge through workshops and guest lectures. Our members participate in stock market simulations and analyze real-world financial cases with industry experts.",
    contact: "https://www.instagram.com/akmalbnazir",
    category: "finance",
    founded: 2025,
    members: 95
  },
  {
    id: 3,
    name: "AK USAAIO Chapter Club",
    description: "Learning machine learning tasks and data science skills to propel the next future of generations.",
    contact: "https://www.instagram.com/ardreykellusaaio/",
    category: "technology",
    founded: 2025,
    members: 20
  },
  {
    id: 4,
    name: "MindsetMath",
    description: "Transforming math anxiety into math mastery through peer tutoring and creative problem-solving sessions. We make advanced mathematics accessible and enjoyable for all skill levels.",
    contact: "https://www.instagram.com/mindset.math/",
    category: "Academic",
    founded: 2023,
    members: 150
  },
  {
    id: 5,
    name: "ProjectUcodeNC",
    description: "Student-run software development collective building real-world applications for nonprofits. Members gain hands-on experience with full-stack development while making social impact.",
    contact: "https://www.instagram.com/projectucode_nc/",
    category: "technology",
    founded: 2025,
    members: 68
  },
  {
    id: 6,
    name: "Alturos Mental Health",
    description: "Promoting mental wellness through mindfulness workshops, peer support groups, and mental health advocacy. We create safe spaces for open dialogue about psychological well-being.",
    contact: "https://www.instagram.com/alturos.mentalhealth/",
    category: "Wellness",
    founded: 2017,
    members: 142

  },
  {
    id: 7,
    name: "Sanitation4Health",
    description: "Keeping our community clean and healthy through regular sanitation drives, educational workshops on hygiene practices, and partnerships with local health organizations.",
    contact: "https://www.instagram.com/sanitation4health/",
    category: "creative",
    founded: 2025,
    members: 35
  },
  
  {
    id: 8,
    name: "JJ Junk Drawer",
    description: "JJ runs a student-led business creating and selling unique handmade cups, shirts, and other custom designs.",
    contact: "https://www.instagram.com/jjsjunkdrawer.us/",
    category: "creative",
    founded: 2025,
    members: 1
  },
  
  {
    id: 9,
    name: "IAYL",
    description: "IAYL empowers Indian American youth through service and advocacy, offering leadership roles and internship opportunities.",
    contact: "https://www.instagram.com/iayouthleadership/",
    category: "community",
    founded: 2023,
    members: 100
    },
  {
    id: 10,
    name: "ProjectInHorizons",
    description: "Project Infinite Horizons(PIH) is a student-led nonprofit organization that is dedicated to raising awareness for neurological conditions faced by kids. We also host various fundraising events to raise money to donate directly to hospitalized kids.",
    contact: "https://www.instagram.com/projectinfinitehorizons/",
    category: "HealthCare",
    founded: 2025,
    members: 20
  },
  {
    id: 11,
    name: "NCAAT",
    description: "NCAAT is an Asian American organization dedicated to addressing the challenges faced by our community through advocacy and education. They offer ambassador programs and internships that provide valuable leadership experience and stipends to support young Asian Americans. Join NCAAT to empower yourself, build skills, and make a meaningful impact.",
    contact: "https://www.instagram.com/ncaatogether/",
    category: "community",
    founded: 2020,
    members: 400
  },
  {
    id: 12,
    name: "CYMA",
    description: "CYMA is a student-led organization that hosts business-related events, promotes marketing skills, and offers multiple leadership positions for members to grow and lead.",
    contact: "https://www.instagram.com/official_cyma/",
    category: "Business",
    founded: 2023,
    members: 100
  },

  {
    id: 13,
    name: "Snack Packs",
    description: "We are Snack Packs for Hope, a non profit based in Ballantyne where we help people who are homeless by giving them food or snack packs ",
    contact: "https://www.instagram.com/snack.packs.for.hope/",
    category: "community",
    founded: 2025,
    members: 5
  },
  {
    id: 14,
    name: "NC TMHA",
    description: "We are a student -run initiative group dedicated to spreading awareness about teen mental health and raising money through fundraisers and speeches to support mental health charities. ",
    contact: "https://www.instagram.com/nc_tmha/",
    category: "Wellness",
    founded: 2025,
    members: 30
  },
  {
    id: 15,
    name: "ESL Teen Tutors",
    description: "Free Multilingual Tutoring. Connect your child with qualified tutors who speak your language and understand your cultural background. Services are free and available in over 25 languages. Visit our website: www.eslteentutors.org",
    contact: "https://www.instagram.com/eslteentutors/",
    category: "Wellness",
    founded: 2025,
    members: 300
  },{
    id: 16,
    name: "Excel Acedame",
    description: "Excel Academy is a fully volunteer-run nonprofit organization dedicated to supporting the education and success of underprivileged students. To strengthen our community and those around us, we implement STEM programs in low-income schools and provide free tutoring and academic support to students across the nation.",
    contact: "https://www.instagram.com/excel_academe_/",
    category: "Academic",
    founded: 2025,
    members: 30
  },{
    id: 17,
    name: "BinBros",
    description: "Cleaning up the environment one bin at a time. We organize community clean-up events, recycling drives, and educational workshops on sustainability practices.",
    contact: "https://www.instagram.com/thebin_bros/",
    category: "Wellness",
    founded: 2025,
    members: 88
  },{
    id: 18,
    name: "ACS",
    description: "We are the CLT community chapter of the American Cancer Society. We host events to raise money for cancer research and provide support for those affected by cancer. We plan to have exciting events for the city of CLT and support our local community",
    contact: "https://www.instagram.com/akacs_/",
    category: "community",
    founded: 2025,
    members: 20
  },{
    id: 19,
    name: "NCSteminate",
    description: "The local North Carolina chapter of Steminate engages students in STEM activities, organizes events, and partners with outreach centers. Join us to develop your skills, make an impact, and take on leadership positions.",
    contact: "https://www.instagram.com/steminate.northcarolina/",
    category: "technology",
    founded: 2025,
    members: 10
  },{
    id: 20,
    name: "UpLife.Clt",
    description: "We are a nonprofit organization committed to helping homeless individuals and supporting shelters to transform lives. Our mission is to enable shelters to accommodate more people and provide essential resources for those in need.",
    contact: "https://www.instagram.com/uplife.clt",
    category: "community",
    founded: 2025,
    members: 20
  },{
    id: 21,
    name: "FBTF",
    description: "Fire & Burn Trauma is a nonprofit organization dedicated to supporting individuals affected by fires and burn-related tragedies, providing comfort, resources, and assistance during difficult times.",
    contact: "https://www.instagram.com/fireandburntraumafoundation/",
    category: "community",
    founded: 2025,
    members: 10
  },
{
    id: 36,
    name: "Filler",
    description: ".",
    contact: "design@example.com",
    category: "community",
    founded: 2025,
    members: 10
  },
{
    id: 37,
    name: "Epidra Project",
    description: "EPIDRA is a community that believes every skin tells a story. We aim to raise awareness about the importance of skincare, sun protection, and understanding skin conditions that are often overlooked or misunderstood.",
    contact: "https://www.instagram.com/epidra.project/",
    category: "Wellness",
    founded: 2025,
    members: 10
  },
{
    id: 38,
    name: "FBTF",
    description: "Fire & Burn Trauma is a nonprofit organization dedicated to supporting individuals affected by fires and burn-related tragedies, providing comfort, resources, and assistance during difficult times.",
    contact: "design@example.com",
    category: "community",
    founded: 2025,
    members: 10
  },
{
    id: 39,
    name: "BeyondtheWhiteCoat",
    description: "Our mission is to uncover the stories, passions, and lives beyond their white coat. We believe that every white coat has a story- and we are here to bring it to life",
    contact: "https://www.instagram.com/beyondthewhitecoat09/",
    category: "community",
    founded: 2025,
    members: 10
  },
{
    id: 40,
    name: "SleekClothingBrand",
    description: "Atharv is a small creative artist who sells his clothing brand Sleek Clothing. He is passionate about fashion and aims to provide stylish and comfortable clothing options for everyone.",
    contact: "https://www.instagram.com/seek_clothing/",
    category: "creative",
    founded: 2025,
    members: 10
  },
{
    id: 41,
    name: "QCB",
    description: "Adi and Rithvik, two friends, started a hair-cutting business providing top-notch haircuts to clients across the city. Their entrepreneurial venture combines skill, creativity, and a passion for serving the community. View their website by Aarya Raut: qcb-website.vercel.app",
    contact: "https://www.instagram.com/queencityblendz/",
    category: "creative",
    founded: 2024,
    members: 50
  },
{
    id: 42,
    name: "ProjectScrubEra",
    description: "Best friends Jia and Chahat hand-crafted hundreds of bracelets and delivered them to multiple clinics and hospitals across North and South Carolina. Each bracelet featured positive phrases designed to encourage and uplift healthcare staff during challenging days, spreading small but meaningful reminders of appreciation and support.",
    contact: "https://www.instagram.com/projectscrubera/",
    category: "community",
    founded: 2025,
    members: 2
  },

{
    id: 43,
    name: "BuddyBaskets",
    description: "Serving your local Ballantyne community and hospitals through creative student-led initiaves. Founded by Gia and Nandini:)",
    contact: "https://www.instagram.com/buddybasketsclt",
    category: "community",
    founded: 2025,
    members: 2
  },
  {
    id: 44,
    name: "QueenCityResells",
    description: " This guy has it all — from colognes to shoes and everything in between. If he gets his hands on it, it is fair game. Do not walk — run to grab your next pickup from him.",
    contact: "https://www.instagram.com/queen.city.resells",
    category: "creative",
    founded: 2025,
    members: 1
  },
  {
    id: 45,
    name: "Thrive2gethr",
    description: "A student led nonprofit fighting food insecurity by partnering with your favorite restaurants.",
    contact: "https://www.instagram.com/thrive2gethr_charlotte",
    category: "community",
    founded: 2025,
    members: 20
  },
  {
    id: 46,
    name: "Cuts4kids.NCS",
    description: "At it again, Ivan Cheah, cutting kids in the youth community, if you have younger sibling, ccome over and get him a fresh fade for no money spent!",
    contact: "https://www.instagram.com/cuts4kids.nc",
    category: "community",
    founded: 2025,
    members: 1
  },
  {
    id: 47,
    name: "T1D United ",
    description: "1D United was founded by Krisha Karamchandani and Krivisha Nuthakki with the mission to raise awareness and funds for Type 1 Diabetes. Through community events, fundraisers, and educational outreach, we aim to spread knowledge, support ongoing research, and empower those affected by Type 1 Diabetes. Our vision is a future where no one faces Type 1 Diabetes alone—and where a cure is within reach.",
    contact: "https://www.instagram.com/direct/t/17843217549556865",
    category: "HealthCare",
    founded: 2025,
    members: 2
  },
  {
    id: 48,
    name: "Ivan Cuts",
    description: "Book a haircut with Ivan Cheah, a professional barber with over 3 years of experience. Get the perfect cut for any occasion.",
    contact: "https://www.instagram.com/ivancuts.nc/",
    category: "Wellness",
    founded: 2022,
    members: 100
  },
  {
    id: 49,
    name: "Echelon Charlotte",
    description: "We are a student-led nonprofit promoting cybersecurity awareness. We host workshops, share resources, and are building a website with a course for kids to learn digital safety.",
    contact: "https://www.instagram.com/echeloncharlotte",
    category: "technology",
    founded: 2025,
    members: 10
  },
  {
    id: 50,
    name: "Mindsnet",
    contact: "",
    description: "Study Smarter | Efficient Learning Tips",
    category: "Academic",
    founded: 2025,
    members: "NA"
  },
  {
    id: 51,
    name: "Hearts in Bloom",
    description: "Based in NC ✦ Healthcare focused ✦ Recognition opportunities for teens ✦ Initiatives with IMPACT Interested? More info coming soon! ˖᯽ ݁˖",
    contact: "https://www.instagram.com/heartsinbloomorg",
    category: "HealthCare",
    founded: 2025,
    members:100
  },
  
  {
    id: 52,
    name: "Vales and Co",
    description: "N/A",
    contact: "https://www.instagram.com/valesandco/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 53,
    name: "NCSAAP",
    description: "N/A",
    contact: "https://www.instagram.com/ncsaap/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 54,
    name: "Ardrey Kell Robotics Club",
    description: "N/A",
    contact: "https://www.instagram.com/akrobotics/",
    category: "technology",
    founded: 2025,
    members: "NA"
  },
  {
    id: 55,
    name: "Every Student Succeeds at Math",
    description: "N/A",
    contact: "https://www.instagram.com/essm/",
    category: "Academic",
    founded: 2025,
    members: "NA"
  },
  {
    id: 56,
    name: "Sebas Depop",
    description: "N/A",
    contact: "https://www.instagram.com/sebasdepop/",
    category: "creative",
    founded: 2025,
    members: "NA"
  },
  {
    id: 57,
    name: "AK NaX",
    description: "N/A",
    contact: "https://www.instagram.com/aknex/",
    category: "technology",
    founded: 2025,
    members: "NA"
  },
  {
    id: 58,
    name: "WISH",
    description: "N/A",
    contact: "https://www.instagram.com/wish/",
    category: "Wellness",
    founded: 2025,
    members: "NA"
  },
  {
    id: 59,
    name: "Mindsnest",
    description: "N/A",
    contact: "https://www.instagram.com/mindsnest/",
    category: "Academic",
    founded: 2025,
    members: "NA"
  },
  {
    id: 60,
    name: "Nightingale",
    description: "N/A",
    contact: "https://www.instagram.com/nightingale/",
    category: "HealthCare",
    founded: 2025,
    members: "NA"
  },
  {
    id: 61,
    name: "Homeless Hearth",
    description: "N/A",
    contact: "https://www.instagram.com/homelesshearth/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 62,
    name: "Another Chance CLT",
    description: "N/A",
    contact: "https://www.instagram.com/anotherchanceclt/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 63,
    name: "Medsearch Charlotte",
    description: "N/A",
    contact: "https://www.instagram.com/medsearchclt/",
    category: "HealthCare",
    founded: 2025,
    members: "NA"
  },
  {
    id: 64,
    name: "CutzForkidz",
    description: "N/A",
    contact: "https://www.instagram.com/cutzforkidz/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 65,
    name: "Within Your Glow",
    description: "N/A",
    contact: "https://www.instagram.com/withinyourglow/",
    category: "Wellness",
    founded: 2025,
    members: "NA"
  },
  {
    id: 66,
    name: "FeedCLT",
    description: "N/A",
    contact: "https://www.instagram.com/feedclt/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 67,
    name: "BrightCareKids",
    description: "BrightCareKids is a student led organization where we help kids with disabilities to thrive and reach their full potential. We aim to provide children with disabilities the tools, experience, and confidence they need to succeed; while raising awareness and building a world where all abilities are valued. We host events, fundraisers, and activities to raise money and awareness to pediatric therapies, ymcas, and disability centers. Be an officer today and make a meaningful difference.",
    contact: "https://www.instagram.com/brightcarekids/",
    category: "HealthCare",
    founded: 2025,
    members: "NA"
  },
  {
    id: 68,
    name: "The Student Unity Network Club",
    description: "N/A",
    contact: "https://www.instagram.com/studentunitynetwork/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 69,
    name: "HelpingHandsMRHS",
    description: "Helping Hands is a student-led organization that operates through high school clubs in order to connect students with volunteer opportunities. Each school chapter is led by students who plan and run service projects, donation drives, and volunteer events. Chapters are connected through Helping Hands HQ, which provides resources, ideas, and support, but each chapter decides what causes to focus on based on the needs of their community.",
    contact: "https://www.instagram.com/helpinghandsmrhs/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 70,
    name: "Teen Volunteer Network CLT",
    description: "We are a Charlotte based organization designed to get local teens more involved in their community through volunteering. We ourselves struggled in the past to find volunteer opportunities accessible to teens. We wished that there was a place that had all the needed information, so we made one ourselves. Our goal is to encourage teens, like us, to get out and help their community more.",
    contact: "https://www.instagram.com/teenvolunteernetworkclt/",
    category: "community",
    founded: 2025,
    members: "NA"
  },
  {
    id: 71,
    name: "Bloom and Soar",
    description: "At Bloom and Soar, we believe that every person deserves to flourish, and no one should face their mental health journey alone. Founded by students who understand the unique challenges of our generation, we’re more than an organization, we’re a movement dedicated to transforming how young people approach mental wellness. Our mission extends beyond awareness into action: we’re building a comprehensive digital sanctuary where you can express yourself anonymously, discover vital resources, and connect with others who truly understand. Together, we bloom where we’re planted and soar toward a brighter tomorrow.",
    contact: "https://www.instagram.com/bloomandsoar/",
    category: "Wellness",
    founded: 2025,
    members: "NA"
  },
  {
  id: 52,
  name: "Nightingale",
  description: "A healthcare-focused organization providing support and resources for medical students and aspiring healthcare professionals through mentorship programs and educational workshops.",
  contact: "https://www.instagram.com/nightingale_health/",
  category: "HealthCare",
  founded: 2025,
  members: "N/A"
},
{
  id: 53,
  name: "Homeless Hearth",
  description: "Dedicated to supporting homeless individuals in our community through shelter assistance, meal programs, and essential resource distribution to help restore dignity and hope.",
  contact: "https://www.instagram.com/homelesshearth/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 54,
  name: "Another Chance CLT",
  description: "Providing second opportunities through community support programs, rehabilitation resources, and educational initiatives for those seeking to rebuild their lives in Charlotte.",
  contact: "https://www.instagram.com/anotherchanceclt/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 55,
  name: "Medsearch Charlotte",
  description: "Connecting students with medical opportunities, shadowing experiences, and healthcare career pathways through partnerships with local medical facilities and professionals.",
  contact: "https://www.instagram.com/medsearchclt/",
  category: "HealthCare",
  founded: 2025,
  members: "N/A"
},
{
  id: 56,
  name: "CutzForkidz",
  description: "Providing free haircuts and grooming services for children in need, helping boost confidence and self-esteem through professional styling and care.",
  contact: "https://www.instagram.com/cutzforkidz/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 57,
  name: "Within Your Glow",
  description: "Promoting self-care, confidence, and inner beauty through workshops, wellness events, and positive community building for students of all backgrounds.",
  contact: "https://www.instagram.com/withinyourglow/",
  category: "Wellness",
  founded: 2025,
  members: "N/A"
},
{
  id: 58,
  name: "FeedClt",
  description: "Combating food insecurity in Charlotte through community food drives, meal distribution programs, and partnerships with local food banks and restaurants.",
  contact: "https://www.instagram.com/feedclt/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 59,
  name: "BrightCareKids",
  description: "BrightCareKids is a student led organization where we help kids with disabilities to thrive and reach their full potential. We aim to provide children with disabilities the tools, experience, and confidence they need to succeed; while raising awareness and building a world where all abilities are valued. We host events, fundraisers, and activities to raise money and awareness to pediatric therapies, ymcas, and disability centers.",
  contact: "https://www.instagram.com/brightcarekids/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 60,
  name: "The Student Unity Network Club",
  description: "Fostering inclusivity and connection among students from diverse backgrounds through cultural events, dialogue sessions, and collaborative projects that build community.",
  contact: "https://www.instagram.com/studentunitynetwork/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 61,
  name: "Helping Hands MRHS",
  description: "Helping Hands is a student-led organization that operates through high school clubs in order to connect students with volunteer opportunities. Each school chapter is led by students who plan and run service projects, donation drives, and volunteer events. Chapters are connected through Helping Hands HQ, which provides resources, ideas, and support, but each chapter decides what causes to focus on based on the needs of their community.",
  contact: "https://www.instagram.com/helpinghandsmrhs/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 62,
  name: "Teen Volunteer Network CLT",
  description: "We are a Charlotte based organization designed to get local teens more involved in their community through volunteering. We ourselves struggled in the past to find volunteer opportunities accessible to teens. We wished that there was a place that had all the needed information, so we made one ourselves. Our goal is to encourage teens, like us, to get out and help their community more.",
  contact: "https://www.instagram.com/teenvolunteernetwork_clt/",
  category: "community",
  founded: 2025,
  members: "N/A"
},
{
  id: 63,
  name: "Bloom and Soar",
  description: "At Bloom and Soar, we believe that every person deserves to flourish, and no one should face their mental health journey alone. Founded by students who understand the unique challenges of our generation, we're more than an organization, we're a movement dedicated to transforming how young people approach mental wellness. Our mission extends beyond awareness into action: we're building a comprehensive digital sanctuary where you can express yourself anonymously, discover vital resources, and connect with others who truly understand.",
  contact: "https://www.instagram.com/bloomandsoar/",
  category: "Wellness",
  founded: 2025,
  members: "N/A"
}
  
];

const categories = ["all", ...new Set(clubs.map(club => club.category))];

export default function Directory() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [expandedClub, setExpandedClub] = useState(null);
  const [sortBy, setSortBy] = useState("name");

  const filteredClubs = clubs
    .filter(club => {
      const matchesSearch = club.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                         club.description.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = selectedCategory === "all" || club.category === selectedCategory;
      return matchesSearch && matchesCategory;
    })
    .sort((a, b) => {
      if (sortBy === "name") return a.name.localeCompare(b.name);
      if (sortBy === "founded") return a.founded - b.founded;
      if (sortBy === "members") return b.members - a.members;
      return 0;
    });

  const toggleExpand = (id) => {
    setExpandedClub(expandedClub === id ? null : id);
  };

  return (
    <div className="directory-container">
      <div className="directory-content">
        <header className="directory-header">
          <h1 className="directory-title">Club & Organization Hub</h1>
          <p className="directory-subtitle">Find your community in our premium directory</p>
        </header>

        <div className="controls-container">
          <div className="search-wrapper">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search clubs..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="filter-sort-container">
            <select
              className="category-select"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category === "all" ? "All Categories" : category.charAt(0).toUpperCase() + category.slice(1)}
                </option>
              ))}
            </select>

            <select
              className="sort-select"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="name">Sort by Name</option>
              <option value="founded">Sort by Newest</option>
              <option value="members">Sort by Popularity</option>
            </select>
          </div>
        </div>

        {filteredClubs.length === 0 ? (
          <div className="no-results">
            <p>No clubs match your search criteria.</p>
            <button 
              className="reset-filters"
              onClick={() => {
                setSearchTerm("");
                setSelectedCategory("all");
              }}
            >
              Reset Filters
            </button>
          </div>
        ) : (
          <div className="clubs-grid">
            {filteredClubs.map((club) => (
              <div key={club.id} className="club-card">
                <div className="club-content">
                  <div className="club-header">
                    <h2 className="club-name">{club.name}</h2>
                    <div className="club-meta">
                      <span className="club-category">{club.category}</span>
                      <span className="club-members">{club.members} members</span>
                    </div>
                  </div>
                  
                  <p className={`club-description ${expandedClub === club.id ? '' : 'collapsed'}`}>
                    {club.description}
                  </p>
                  
                  <div className="club-details">
                    <div className="club-stats">
                      <span className="stat">Founded: {club.founded}</span>
                      <span className="stat">Category: {club.category}</span>
                    </div>
                    
                    <div className="club-footer">
                      <button
                        onClick={() => toggleExpand(club.id)}
                        className="toggle-button"
                      >
                        {expandedClub === club.id ? (
                          <>
                            Show Less <FiChevronDown className="rotate-180" />
                          </>
                        ) : (
                          <>
                            Read More <FiChevronDown />
                          </>
                        )}
                      </button>
                      <a
  href={club.contact}  
  target="_blank"      
  rel="noopener noreferrer"
  className="contact-link"
>
  <FiMail /> Contact
</a>

                      
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}